import React from 'react';
import QueryObjectTable from "mrf/view/QueryObjectTable";
import PageTitle from "mrf/view/Title";
import EditButton from "mrf/view/EditButton";
import {Grid} from "mrf/view/Grid";

export default function TranslationLanguageList({ match }) {
    const fields = [
        { name: 'Id', key: 'id' },
        { name: 'Name', key: 'name' },
        { name: 'Code', key: 'code' },
        {
            name: '',
            map: ({ id }) => <EditButton match={match} id={id} />,
            align: 'right',
        },
    ];

    return (
        <Grid cols={1}>
            <PageTitle>Translation Languages</PageTitle>
            <QueryObjectTable
                resource='translationLanguages'
                fields={fields}
            />
            {/*<Flex justify='end'>
                <NewCrudButton className='shadow max-h-10 mt-1' match={match} label='New Translation Language' />
            </Flex>*/}
        </Grid>
    );
}
